import { observer } from "mobx-react";
import {
  initUserSettingsPage,
  prepUserSettings,
  showSsoFeedback,
  UserSettingsTab,
} from "@/userSettings/userSettingsDomain.ts";
import { useEffect } from "react";
import { fromQueryString, singleValue } from "@/utils/queryParams";
import { useDispatch, useRootStore } from "@/stores/RootStoreContext.ts";
import { UserSettingsView } from "@/userSettings/userSettingsComponents.tsx";

export const UserSettingsPage = observer(
  ({ userSettingsTab }: { userSettingsTab: UserSettingsTab }) => {
    const { userStore, userSettings, queryParams, messageStore, location } = useRootStore();
    const dispatch = useDispatch();

    const referrer = singleValue(queryParams.referrer);

    useEffect(() => {
      dispatch(initUserSettingsPage(userSettings, referrer));
    }, [dispatch, userSettings, referrer]);

    useEffect(() => {
      dispatch(showSsoFeedback(userSettingsTab, fromQueryString(location.search)));
    }, [dispatch, userSettingsTab, location.search]);

    return (
      <UserSettingsView
        {...prepUserSettings({
          messageStore,
          userSettingsTab,
          dispatch,
          state: userSettings ?? { isLoading: true },
          user: userStore.user,
          isNorwegianAuthenticatedCountry: userStore.isNorwegianAuthenticatedCountry,
          refreshUser: userStore.refreshUserInformation,
        })}
      />
    );
  },
);
